import { useContext, useState } from 'react'
import { PopupBody, PopupText, WarnIcon } from '../popup-styles'
import Popup from '../popup'
import { BookedSeat } from '../../../../types/andTypes'
import GroupBookingChip from '../../../atoms/Chip/group-booking-chip'
import { BookingChipContainer } from '../group-booking-popup/group-booking-popup-styles'
import warnIcon from '../assets/error.svg'
import { ModalContext } from '../../../../contexts/modal-context'

type ReassignPopupProps = {
  header: string
  decisionText?: string
  groupMembers: Array<BookedSeat>
  confirmAction: (userID: string) => void
  warn?: boolean
}

const ReassignPopup = ({
  header,
  decisionText,
  confirmAction,
  groupMembers,
  warn
}: ReassignPopupProps) => {
  const { setModalOpen } = useContext(ModalContext)
  const [selectedUser, setSelectedUser] = useState<number>(0)

  const closeModal = () => {
    setModalOpen(false)
  }

  const buttonConfig = [
    {
      text: 'Confirm',
      onClick: () => confirmAction(groupMembers[selectedUser].userId)
    }
  ]

  return (
    <Popup header={header} buttonConfig={buttonConfig} onPopupClose={closeModal}>
      {warn ? <WarnIcon data-testid={'warn-icon'} src={warnIcon} alt="warning" /> : <></>}
      {decisionText ? <PopupText data-testid="decision-popup">{decisionText}</PopupText> : <></>}
      <PopupBody>
        <BookingChipContainer data-testid="booking-details">
          {groupMembers.map((item, index) => (
            <GroupBookingChip
              userName={item.name}
              isOrganiser={false}
              key={item.name}
              assignable={true}
              onClick={() => setSelectedUser(index)}
              selected={selectedUser === index}
            />
          ))}
        </BookingChipContainer>
      </PopupBody>
    </Popup>
  )
}

export default ReassignPopup
